import each from 'lodash/each';
import pick from 'lodash/pick';
import map from 'lodash/map';
import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import requestService from 'viralstyle-ui/src/requestService';

class StoresApi {
  getStores(collection) {

    let url = `${hateoas.url('client_stores')}?page={page}&limit={limit}`;

    if (collection.query) {
      url += `&filters[]=title_like:${encodeURIComponent(collection.query)}`;
    }

    url = url.assignParams({ clientId: storage.get('client-hash'), page: collection.page, limit: collection.limit });

    url += `&sort=${collection.sortColumn}:${collection.sortDirection === 0 ? 'DESC' : 'ASC'}`

    return requestService.get(url)
  }

  getStore(storeId) {
    return requestService.get(hateoas.url('client_store_details', { clientId: storage.get('client-hash'), storeId }));
  }

  saveOrUpdateStore(storeId, store, domainId, sortBy) {
    let payload = pick(store, ['name', 'description', 'banner_bg_color', 'banner_image_data_uri', 'tags', 'enable_sort_and_filter']);

    payload.activate = store.is_online;
    payload.store_url = store.url;
    payload.sort_by = sortBy;
    payload.tags = store.is_tag_based ? payload.tags : [];

    if (domainId && domainId !== 'VS') {
      payload.domain_id = domainId;
    } else if (store.domain_id && store.domain_id !== 'VS') {
      payload.domain_id = store.domain_id;
    }

    if (storeId) {
      return requestService.put(hateoas.url('update_client_store', { clientId: storage.get('client-hash'), storeId: storeId }), payload);
    } else {
      return requestService.post(hateoas.url('create_client_store', { clientId: storage.get('client-hash') }), payload);
    }
  }

  updateCampaigns(storeId, store) {
    let campaign_ids = map(store.campaigns, campaign => campaign.campaign_id || campaign.id);

    return requestService.put(hateoas.url('update_store_campaigns', { clientId: storage.get('client-hash'), storeId: storeId }), { campaign_ids });
  }

  updateBanner(storeId, store) {
    return requestService.put(hateoas.url('update_store_logo', { clientId: storage.get('client-hash'), storeId: storeId }), { banner_image_data_uri: store.banner_image_data_uri });
  }

  disableStore(store) {
    return requestService.delete(hateoas.url('disable_store', { clientId: storage.get('client-hash'), store: store.id }));
  }

  getCampaignsByTags(store) {
    let url = hateoas.url('get_eligible_tag_based_campaigns', { clientId: storage.get('client-hash') }),
      params = [];

    each(store.tags, tag => params.push(`tags[]=${tag}`));

    if (store.domain_id && store.domain_id !== 'VS') {
      params.push(`domain_id=${store.domain_id}`);
    }

    if (params.length) {
      url = `${url}?${params.join('&')}`;
    }

    return requestService.get(url);
  }

  getClientTags(domainId) {
    let url = hateoas.url('client_used_tags', { clientId: storage.get('client-hash') });

    if (domainId) url = `${url}?domain_id=${domainId}`;

    return requestService.get(url);
  }

  toggleActivated(store, activate) {
    return requestService.put(hateoas.url('update_client_store_activation', { clientId: storage.get('client-hash'), storeId: store.id }), { activate });
  }
}

export default new StoresApi()